import { render, staticRenderFns } from "./FormConfigDialog.vue?vue&type=template&id=79271eda&"
import script from "./FormConfigDialog.vue?vue&type=script&lang=js&"
export * from "./FormConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./FormConfigDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports